// Guest presentation is independent of the saved account preference.
export function pageTheme(pathname: string, saved: string | null) {
  return /^\/(?:s|c|call)(?:\/|$)/.test(pathname) ? 'light' : saved === 'dark' ? 'dark' : 'light';
}

export function readAccountTheme() {
  let saved: string | null = null;
  try { saved = localStorage.getItem('skrepka.theme'); } catch { /* Private storage may be unavailable. */ }
  return saved === 'dark' ? 'dark' : 'light';
}

export function applyPageTheme(pathname: string) {
  const saved = readAccountTheme();
  const theme = pageTheme(pathname, saved);
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#212121' : '#00a89c');
}
